import cn from 'clsx'
import {
  StyledSectionTitle,
  StyledTitle,
  StyledSubtitle,
  StyledDesc
} from './style'

const SectionTitle = ({
  title,
  subtitle,
  description,
  layout = 1,
  textAlign = 'center',
  className,
  descProps,
  ...props
}) => {
  if (layout === 1) {
    return (
      <StyledSectionTitle
        className={cn(className, 'section-title')}
        $layout={layout}
        textAlign={textAlign}
        {...props}
      >
        {subtitle && (
          <StyledSubtitle $layout={layout}>{subtitle}</StyledSubtitle>
        )}
        {title && (
          <StyledTitle
            $layout={layout}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {description && <StyledDesc {...descProps}>{description}</StyledDesc>}
      </StyledSectionTitle>
    )
  }
  return (
    <StyledSectionTitle
      className={cn(className, 'section-title')}
      textAlign={textAlign}
      $layout={layout}
      {...props}
    >
      {title && (
        <StyledTitle
          $layout={layout}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {subtitle && <StyledSubtitle $layout={layout}>{subtitle}</StyledSubtitle>}
      {description && <StyledDesc {...descProps}>{description}</StyledDesc>}
    </StyledSectionTitle>
  )
}

export default SectionTitle
